// extracted by mini-css-extract-plugin
module.exports = {"form":"Form__form--3CkutdkCU66uxowu9qg6jD"};